exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{.v-main[data-v-7559151d]{padding:0!important}}.dtv-app-bar[data-v-7559151d]{background-color:#1d2329}", ""]);

// exports
